/* Tomi Björck · free gift campaign page
   Choose a gift → swap any previous gift line in the cart → add the new one(s) → redirect.
   Also: countdown, sticky bar, anchor jump. */
(function () {
  'use strict';

  var GIFT_PROPERTY = '_lahja';
  var TOAST_MS = 3200;

  function init(root) {
    if (!root || root.dataset.tlReady) return;
    root.dataset.tlReady = '1';
    if (root.dataset.state === 'ended') return;
    initCountdown(root);
    initChoose(root);
    initShop(root);
    initSticky(root);
    initJump(root);
    restoreChoice(root);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function routes() {
    var r = (window.FoxTheme && FoxTheme.routes) || {};
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return {
      root: root,
      add: r.cart_add_url || root + 'cart/add',
      change: r.cart_change_url || root + 'cart/change',
      update: r.cart_update_url || root + 'cart/update',
      cart: r.cart_url || root + 'cart'
    };
  }

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    var box = root.querySelector('[data-tl-countdown]');
    var ends = Date.parse(root.dataset.ends || '');
    if (!box || isNaN(ends)) return;
    var els = {
      d: box.querySelector('[data-tl-cd="d"]'),
      h: box.querySelector('[data-tl-cd="h"]'),
      m: box.querySelector('[data-tl-cd="m"]'),
      s: box.querySelector('[data-tl-cd="s"]')
    };
    var label = box.querySelector('.tl-countdown__label');
    var timer;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = ends - Date.now();
      if (left <= 0) {
        box.classList.add('is-over');
        if (label) label.textContent = root.dataset.countdownOver || label.textContent;
        clearInterval(timer);
        return;
      }
      var sec = Math.floor(left / 1000);
      var d = Math.floor(sec / 86400);
      var h = Math.floor((sec % 86400) / 3600);
      var m = Math.floor((sec % 3600) / 60);
      var s = sec % 60;
      els.d.textContent = String(d);
      els.h.textContent = pad(h);
      els.m.textContent = pad(m);
      els.s.textContent = pad(s);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- choose a gift ---------- */
  function initChoose(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tl-choose]');
      if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
      e.preventDefault();
      chooseGift(root, btn);
    });
  }

  function fetchJson(url, opts) {
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  /* Remove every cart line that carries the gift property, except lines of `keep`, in ONE atomic update call. */
  function removeOtherGifts(r, keep) {
    return fetchJson(r.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok || !res.data || !res.data.items) return;
      var updates = {};
      var found = false;
      res.data.items.forEach(function (item) {
        var tag = item.properties && item.properties[GIFT_PROPERTY];
        if (tag && tag !== keep) { updates[item.key] = 0; found = true; }
      });
      if (!found) return;
      return fetchJson(r.update + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    });
  }

  function chooseGift(root, btn) {
    var r = routes();
    var ids = (btn.getAttribute('data-variants') || '').split(',').map(function (v) { return parseInt(v, 10); }).filter(Boolean);
    if (!ids.length) return;
    var card = btn.closest('[data-tl-card]');
    var name = btn.getAttribute('data-name') || '';
    var properties = {};
    properties[GIFT_PROPERTY] = name;

    root.dataset.tlBusy = '1';
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = root.dataset.labelBusy || btn.textContent;
    root.querySelectorAll('[data-tl-choose]').forEach(function (b) { if (b !== btn) b.disabled = true; });

    removeOtherGifts(r, null)
      .then(function () {
        return fetchJson(r.add + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) { return { id: id, quantity: 1, properties: properties }; })
          })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'add failed');
        /* Verification pass: the theme drawer may have re-posted a stale line while we were swapping. */
        return removeOtherGifts(r, name).then(function () { return res; });
      })
      .then(function (res) {
        delete root.dataset.tlBusy;
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        root.querySelectorAll('[data-tl-choose]:not([data-tl-soldout])').forEach(function (b) { b.disabled = false; });
        markChosen(root, name);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        var next = root.querySelector('[data-tl-next]');
        if (next) {
          var top = next.getBoundingClientRect().top + window.pageYOffset - 120;
          window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        }
      })
      .catch(function () {
        delete root.dataset.tlBusy;
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.textContent = btn.getAttribute('data-label-default') || btn.textContent;
        root.querySelectorAll('[data-tl-choose]:not([data-tl-soldout])').forEach(function (b) { b.disabled = false; });
        showToast(root, root.dataset.labelError || 'Lahjaa ei voitu lisätä. Yritä uudelleen.');
      });
  }

  /* Chosen state: the card of `name` shows "Valittu", the others go back to normal, the next-step row appears. */
  function markChosen(root, name) {
    root.querySelectorAll('[data-tl-card]').forEach(function (card) {
      var b = card.querySelector('[data-tl-choose]');
      var isIt = b && b.getAttribute('data-name') === name;
      card.classList.toggle('is-chosen', !!isIt);
      if (b) {
        b.classList.toggle('is-done', !!isIt);
        if (!b.hasAttribute('data-tl-soldout')) b.textContent = isIt ? (root.dataset.labelDone || b.textContent) : (b.getAttribute('data-label-default') || b.textContent);
      }
    });
    var chosen = !!name;
    var next = root.querySelector('[data-tl-next]');
    if (next) {
      var giftEl = next.querySelector('[data-tl-next-gift]');
      if (giftEl) giftEl.textContent = name || '';
      next.hidden = !chosen;
    }
    var stickyText = root.querySelector('[data-tl-sticky-text]');
    var stickyBtn = root.querySelector('[data-tl-sticky-btn]');
    if (stickyText) stickyText.textContent = stickyText.getAttribute(chosen ? 'data-chosen' : 'data-default') || stickyText.textContent;
    if (stickyBtn) {
      stickyBtn.textContent = stickyBtn.getAttribute(chosen ? 'data-chosen' : 'data-default') || stickyBtn.textContent;
      stickyBtn.setAttribute('href', chosen ? (stickyBtn.getAttribute('data-chosen-href') || '#') : '#lahjat');
      if (chosen) stickyBtn.removeAttribute('data-tl-jump'); else stickyBtn.setAttribute('data-tl-jump', '');
    }
  }

  /* A visitor who already has a gift in the cart sees the chosen state on load. */
  function restoreChoice(root) {
    var pending = null;
    function sync() {
      if (root.dataset.tlBusy) return;
      fetchJson(routes().cart + '.js', { headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok || !res.data || !res.data.items) return;
        var gift = res.data.items.filter(function (i) { return i.properties && i.properties[GIFT_PROPERTY]; })[0];
        markChosen(root, gift ? gift.properties[GIFT_PROPERTY] : null);
      }).catch(function () {});
    }
    function schedule() { clearTimeout(pending); pending = setTimeout(sync, 250); }
    sync();
    /* Keep the page in step with the cart: a gift removed in the drawer resets the cards. */
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:refresh', schedule);
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  /* ---------- on-page products: add to cart and open the theme drawer ---------- */
  function initShop(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tl-add]');
      if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
      e.preventDefault();
      var r = routes();
      var id = parseInt(btn.getAttribute('data-tl-add'), 10);
      btn.classList.add('is-busy');
      fetchJson(r.add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) throw new Error('add failed');
        btn.classList.add('is-done');
        btn.textContent = btn.getAttribute('data-label-added') || btn.textContent;
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = btn.getAttribute('data-label-default') || btn.textContent;
        }, 1800);
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        } else {
          window.location.href = r.cart;
        }
      }).catch(function () {
        btn.classList.remove('is-busy');
        showToast(root, root.dataset.labelError || 'Lisäys ei onnistunut. Yritä uudelleen.');
      });
    });
  }

  function showToast(root, text) {
    var toast = root.querySelector('[data-tl-toast]');
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, TOAST_MS);
  }

  /* ---------- sticky bar: visible while the gift cards are off screen ---------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-tl-sticky]');
    var gifts = root.querySelector('#lahjat');
    if (!bar || !gifts || !('IntersectionObserver' in window)) return;
    var heroSeen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === gifts) {
          var show = !entry.isIntersecting && heroSeen;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      });
    }, { threshold: 0.05 });
    io.observe(gifts);
    /* Only start showing once the visitor has scrolled past the hero fold. */
    var hero = root.querySelector('.tl-hero');
    if (hero) {
      var heroIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (!entry.isIntersecting) heroSeen = true; });
      }, { threshold: 0.2 });
      heroIo.observe(hero);
    }
  }

  /* ---------- anchor jump ---------- */
  function initJump(root) {
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-tl-jump]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('data-tl-jump') || 'lahjat');
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    });
  }

  function boot() { document.querySelectorAll('.tl').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.tl');
    if (root) { delete root.dataset.tlReady; init(root); }
  });
})();
